import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PEImmigrationBenefitsCardActions = {
  initPeImmigrationBenefitsCard: ({ commit }, index) => {
    commit('setPeImmigrationBenefitsCardLock', { index, lock: true })
  },
  peImmigrationBenefitsCardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      post('/party_characteristics', {
        immigration_benefits: {
          party_id: party.id,
          initiated_date: section.initiated_date,
          initiated_date_uncertain: section.initiated_date_uncertain,
          benefit_type: section.benefit_type,
          nvc_number: section.nvc_number,
          other_identifier: section.other_identifier,
          benefit_outcome: section.benefit_outcome,
          outcome_date: section.outcome_date,
          outcome_date_uncertain: section.outcome_date_uncertain,
          notes: section.notes,
          a_number: section.a_number,
        },
      }).
      then(({ data }) => {
        commit('setPeImmigrationBenefitsCardLock', { index: 'new', lock: true })
        commit('setPeImmigrationBenefitsCardLock', { index: data.id, lock: true })
        commit('pePatchCharacteristicNew', {
          characteristic: 'immigration_benefits',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peImmigrationBenefitsCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/party_characteristics/immigration_benefits/${section.id}`).
      then(({ data }) => {
        commit('setPeImmigrationBenefitsCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'immigration_benefits',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peImmigrationBenefitsCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/party_characteristics/${id}`, {
        immigration_benefits: {
          party_id: party.id,
          initiated_date: section.initiated_date,
          initiated_date_uncertain: section.initiated_date_uncertain,
          benefit_type: section.benefit_type,
          nvc_number: section.nvc_number,
          other_identifier: section.other_identifier,
          benefit_outcome: section.benefit_outcome,
          outcome_date: section.outcome_date,
          outcome_date_uncertain: section.outcome_date_uncertain,
          notes: section.notes,
          a_number: section.a_number,
        },
        id,
      }).
      then(({ data }) => {
        commit('setPeImmigrationBenefitsCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'immigration_benefits',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peImmigrationBenefitsCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/party_characteristics/${id}`, {
        data: {
          immigration_benefits: {
            party_id: party.id,
          },
          id,
        },
      }).
      then(({ data }) => {
        const immigrationBenefits = data.immigration_benefits

        commit('setPeImmigrationBenefitsCardLock', { index, lock: true })
        commit('pePatchParty', {
          immigration_benefits: immigrationBenefits || [],
        })
      }).
      catch(handleError)
  },
  peImmigrationBenefitsCardAddSection: ({ commit }) => {
    commit('setPeImmigrationBenefitsCardLock', { index: 'new', lock: false })
    commit('addPeImmigrationBenefitsCardSection', {
      id: null,
      initiated_date: null,
      initiated_date_uncertain: null,
      benefit_type: null,
      nvc_number: null,
      other_identifier: null,
      benefit_outcome: null,
      outcome_date: null,
      outcome_date_uncertain: null,
      notes: null,
      a_number: null,
    })
  },
}

export const PEImmigrationBenefitsCardMutations = {
  setPeImmigrationBenefitsCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.ImmigrationBenefitsCard) {
      Vue.set(state.partyEdit.partySections, 'ImmigrationBenefitsCard', {})
    }
    Vue.set(state.partyEdit.partySections.ImmigrationBenefitsCard, index, lock)
  },
  addPeImmigrationBenefitsCardSection: (state, section) => {
    state.partyEdit.party.immigration_benefits.push(section)
  },
  peImmigrationBenefitsCardCreateUndo: state => {
    state.partyEdit.party.immigration_benefits.pop()
    Vue.set(state.partyEdit.partySections.ImmigrationBenefitsCard, 'new', true)
  },
}

export const PEImmigrationBenefitsCardGetters = {
  peImmigrationBenefitsCardLock: state => index => state.partyEdit.partySections.ImmigrationBenefitsCard[index],
  peImmigrationBenefitsCardHasNewSection: (_, getters) => !!getters.
    peParty.
    immigration_benefits?.
    find(language => language.id === null),
}
